import Vue      from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter)

import CAppHome         from "@/modules/core/components/app/CAppHome";
import MCustomer        from "@/modules/msd/company/customer/components/main/MCustomer";
import MSite            from "@/modules/msd/unit/components/main/MSite";
import MSiteOverview    from "@/modules/msd/unit/components/main/MSiteOverview";
import MInspection      from "@/modules/msd/company/inspection/components/main/MInspection";
import MService         from "@/modules/msd/company/servicepartner/components/main/MService";
import MPreferences     from "@/modules/msd/preferences/components/main/MPreferences";
import MIncOverview     from "@/modules/inc/overview/MIncOverview";
import MIncident        from "@/modules/inc/steps/components/MIncident";
import CrmCalendar      from "@/modules/inc/steps/components/MCalendar";
import MInbox           from "@/modules/inb/components/main/MInbox";
import MDmsExport from "@/modules/dms/export/components/MDmsExport.vue";
import MDmsTreeview from "@/modules/dms/treeview/components/MDmsTreeview.vue";
import MIncOutbox from "@/modules/inc/outbox/components/MIncOutbox.vue";
import MDisposition from "@/modules/dis/components/MDisposition.vue";
import MImportHome from "@/modules/msd/importer/components/MImportHome.vue";

const routes = [
    {
        name: "home",
        path: "/",
        component: CAppHome
    },
    {
        name: "incident",
        path: "/incident/:id",
        component: MIncident
    },
    {
        name: "incidents",
        path: "/incident",
        component: MIncOverview
    },
    {
        name: "calendar",
        path: "/calendar",
        component: CrmCalendar
    },
    {
        name: "imports",
        path: "/imports",
        component: MInbox
    },
    {
        name: "outbox",
        path: "/outbox",
        component: MIncOutbox
    },
    {
        name: "customer",
        path: "/customer",
        component: MCustomer
    },
    {
        name: "sites",
        path: "/sites",
        component: MSite
    },
    {
        // the sites page with the site's dialog open (deep link)
        name: "site",
        path: "/sites/:siteId",
        component: MSite
    },
    {
        name: "sitelist",
        path: "/sitelist",
        component: MSiteOverview
    },
    {
        name: "service",
        path: "/service",
        component: MService
    },
    {
        name: "zues",
        path: "/zues",
        component: MInspection
    },
    {
        name: "preferences",
        path: "/preferences",
        component: MPreferences
    },
    {
        name: "import",
        path: "/import/:id",
        component: MImportHome
    },
    {
        name: "docexport",
        path: "/docexport",
        component: MDmsExport
    },
    {
        name: "documents",
        path: "/documents",
        component: MDmsTreeview
    },
    {
        name: "disposition",
        path: "/disposition",
        component: MDisposition
    },
];

export const router = new VueRouter({
    mode: "history",
    base: "/",
   routes
});

const forceHomeOnRefresh = [
    "incidents",
    "sitelist"
];

router.beforeEach((to, from, next) => {
    if (forceHomeOnRefresh.includes(to.name) && !from.name) {
        next({
            name: 'home'
        })
    } else {
        next()
    }
})